var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAllDone = function SvgAllDone(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243,
    height: 127,
    viewBox: "0 0 243 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.212 76.3136L137.536 72.5498C137.108 72.0519 136.799 71.4445 136.6 70.7574C136.6 70.7674 135.744 71.8129 133.075 70.8271C131.601 70.2795 130.835 69.0547 130.506 67.5213C130.506 67.5213 128.007 68.7162 126.782 66.1771C125.458 63.409 124.462 53.8999 131.98 49.5884C135.684 47.4675 151.088 48.2143 164.51 48.3338L172.994 41.2841L142.893 46.2627L152.103 17.1776L129.471 37.6397L121.495 8.18628L113.519 37.6397L90.8864 17.1776L100.097 46.2627L69.9961 41.2841L78.9775 48.7321C92.2804 48.6026 107.356 47.8957 111.01 49.9867C118.538 54.2982 117.542 63.8073 116.208 66.5754C114.983 69.1145 112.484 67.9196 112.484 67.9196C112.155 69.4531 111.388 70.6778 109.915 71.2254C107.246 72.2112 106.4 71.1757 106.39 71.1557C106.201 71.7831 105.932 72.3406 105.553 72.8186L106.778 76.3036C103.821 78.773 98.6729 79.1215 96.4126 79.1215C95.5663 79.1215 94.8394 79.0319 94.1523 78.9224L78.7087 101.864L106.191 88.6008L105.543 119.11L121.495 93.1014L137.446 119.11L136.799 88.6008L164.281 101.864L148.837 78.9224C148.15 79.0418 147.423 79.1215 146.577 79.1215C144.317 79.1215 139.169 78.773 136.212 76.3036V76.3136Z",
    fill: "#9874FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M234.767 55.7698C238.422 44.1298 248.439 20.581 231.004 16.3791C219.881 13.7006 215.55 25.2211 210.94 32.4102C201.47 47.1568 180.64 48.4512 175.213 48.6404C160.775 49.1383 137.465 47.3161 132.786 49.9946C125.258 54.3061 126.254 63.8152 127.588 66.5833C128.813 69.1224 131.312 67.9276 131.312 67.9276",
    stroke: "#212124",
    strokeWidth: 2.69161,
    strokeMiterlimit: 10,
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.532 55.4414C133.532 55.4414 127.847 68.9932 133.881 71.2335C136.559 72.2293 137.406 71.1638 137.406 71.1638",
    stroke: "#212124",
    strokeWidth: 2.69161,
    strokeMiterlimit: 10,
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M139.385 58.4077C139.385 58.4077 134.596 70.0278 138.818 73.4232C143.02 76.8087 148.128 73.7717 148.974 67.8571",
    stroke: "#212124",
    strokeWidth: 2.69161,
    strokeMiterlimit: 10,
    fill: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M149.895 62.3503C148.979 63.9335 145.593 65.5964 142.277 65.5267",
    stroke: "#212124",
    strokeWidth: 2.69161,
    strokeMiterlimit: 10,
    fill: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M145.035 65.2214L144.258 69.6922",
    stroke: "#212124",
    strokeWidth: 2.69161,
    strokeMiterlimit: 10,
    fill: "none"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M136.211 76.3135C139.168 78.7828 144.316 79.1313 146.576 79.1313C151.655 79.1313 154.771 74.5311 156.832 73.9337C167.955 70.6876 197.119 62.2439 197.119 62.2439",
    stroke: "#212124",
    strokeWidth: 2.69161,
    strokeMiterlimit: 10,
    fill: "none"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M227.954 23.7178C226.271 27.4916 224.668 29.1146 221.681 28.6167C216.752 27.7903 214.631 34.2027 218.435 35.8955C220.994 37.0405 223.613 38.2553 223.613 38.2553",
    stroke: "#212124",
    strokeWidth: 2.69161,
    strokeLinejoin: "round",
    fill: "none"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M223.642 23.0803L222.457 25.6891",
    stroke: "#212124",
    strokeWidth: 2.69161,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M231.759 26.7927L230.574 29.4115",
    stroke: "#212124",
    strokeWidth: 2.69161,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M8.23164 55.7698C4.57734 44.1298 -5.43965 20.581 11.9954 16.3791C23.1177 13.7006 27.4491 25.2211 32.0593 32.4102C41.5286 47.1568 62.3591 48.4512 67.7858 48.6404C82.2237 49.1383 105.534 47.3161 110.213 49.9946C117.741 54.3061 116.745 63.8152 115.411 66.5833C114.186 69.1224 111.687 67.9276 111.687 67.9276",
    stroke: "#212124",
    strokeWidth: 2.69161,
    strokeMiterlimit: 10,
    fill: "none"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M109.455 55.4414C109.455 55.4414 115.141 68.9932 109.107 71.2335C106.428 72.2293 105.582 71.1638 105.582 71.1638",
    stroke: "#212124",
    strokeWidth: 2.69161,
    strokeMiterlimit: 10,
    fill: "none"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M103.612 58.4077C103.612 58.4077 108.402 70.0278 104.18 73.4232C99.9779 76.8087 94.8698 73.7717 94.0234 67.8571",
    stroke: "#212124",
    strokeWidth: 2.69161,
    strokeMiterlimit: 10,
    fill: "none"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1055 62.3503C94.0215 63.9335 97.407 65.5964 100.723 65.5267",
    stroke: "#212124",
    strokeWidth: 2.69161,
    strokeMiterlimit: 10,
    fill: "none"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9648 65.2214L98.7415 69.6922",
    stroke: "#212124",
    strokeWidth: 2.69161,
    strokeMiterlimit: 10,
    fill: "none"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M106.779 76.3135C103.822 78.7828 98.6742 79.1313 96.4139 79.1313C91.3358 79.1313 88.2192 74.5311 86.158 73.9337C75.0358 70.6876 45.8711 62.2439 45.8711 62.2439",
    stroke: "#212124",
    strokeWidth: 2.69161,
    strokeMiterlimit: 10,
    fill: "none"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16.2969 23.7991C17.6909 27.6923 19.1745 29.4348 22.1915 29.156C27.1701 28.698 28.8131 35.2499 24.89 36.6638C22.2513 37.6097 19.5529 38.6254 19.5529 38.6254",
    stroke: "#212124",
    strokeWidth: 2.69161,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M20.6367 23.4797L21.6324 26.1781",
    stroke: "#212124",
    strokeWidth: 2.69161,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M12.2734 26.5857L13.2592 29.2841",
    stroke: "#212124",
    strokeWidth: 2.69161,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M108.098 0V16.3896",
    stroke: "#13C2C2",
    strokeWidth: 2.69161,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M116.81 8.19507H100.68",
    stroke: "#13C2C2",
    strokeWidth: 2.69161,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M146.613 100.02V116.409",
    stroke: "#13C2C2",
    strokeWidth: 2.69161,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M155.314 108.215H139.184",
    stroke: "#13C2C2",
    strokeWidth: 2.69161,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M84.6289 29.0957V38.3758",
    stroke: "#212124",
    strokeWidth: 2.69161,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M89.5565 33.7351H80.4258",
    stroke: "#212124",
    strokeWidth: 2.69161,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M165.285 25.04V37.0683",
    stroke: "#212124",
    strokeWidth: 2.69161,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M171.679 31.0537H159.84",
    stroke: "#212124",
    strokeWidth: 2.69161,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M116.68 114.181V126.209",
    stroke: "#212124",
    strokeWidth: 2.69161,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M123.062 120.195H111.223",
    stroke: "#212124",
    strokeWidth: 2.69161,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M73.7656 81.7566V93.7849",
    stroke: "#13C2C2",
    strokeWidth: 2.69161,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M80.1576 87.7703H68.3086",
    stroke: "#13C2C2",
    strokeWidth: 2.69161,
    strokeMiterlimit: 10
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAllDone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "allDone.efbc246005100b8da10a0beaa036c99d.svg";